import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { Button } from 'next-common-lib';
import i18n from 'i18n';
import {
  DRIVE_URL_CONFIG,
  MEETING_URL_CONFIG,
  MESSENGER_DOWNLOAD_URL,
  TERMS_TYPE,
} from 'constants/IncorporationConstants';
import img_registered from 'assets/img/img_registered.png';
import * as employeeActions from 'redux/ducks/Employee/EmployeeDucks';

export const InviteCompletion = () => {
  const { menu } = useParams();
  const dispatch = useDispatch();
  const { meetingDomain, driveDomain } = useSelector(state => state.employee);
  const serviceCdList = useSelector(state => state[menu].svcType);

  useEffect(() => {
    if (serviceCdList?.includes(TERMS_TYPE.DRIVE)) {
      dispatch(employeeActions.getDriveDomain(DRIVE_URL_CONFIG));
    }
    if (serviceCdList?.includes(TERMS_TYPE.MEETING)) {
      dispatch(employeeActions.getMeetingDomain(MEETING_URL_CONFIG));
    }
  }, [serviceCdList]);

  return (
    <div className="brity-container registered-area">
      <div className="brity-contents">
        <div className="brity-content-area">
          <div className="registered-area">
            <div className="registered-text-area">
              <img src={img_registered} alt="" />
              <div className="title">{i18n.t('MB_T_CONCRATULATION')}</div>
              <div className="text">
                {i18n.t('MB_T_SUCCESS_REGISTER')}
                <Trans i18nKey={i18n.t('MB_T_SERVICE_TRY')} />
              </div>
              <div className="etc-text">
                {i18n.t('MB_T_AVAILABLE_SERVICE')}{' '}
                {serviceCdList.includes(TERMS_TYPE.MESSENGER) && `${i18n.t('MB_T_Messenger')}`}
                {serviceCdList.includes(TERMS_TYPE.MEETING) && ` / ${i18n.t('MB_T_MEETING')}`}
                {serviceCdList.includes(TERMS_TYPE.DRIVE) && ` / ${i18n.t('MB_T_Drive')}`}
              </div>
            </div>
            <div className="registered-button-area">
              <Button
                componentType="solid"
                className="primary "
                label={i18n.t('MB_T_GOTO_DOWNLOAD')}
                disabled={!serviceCdList.includes(TERMS_TYPE.MESSENGER)}
                onClick={() => {
                  window.location.href = MESSENGER_DOWNLOAD_URL;
                }}
              />
              <Button
                componentType="solid"
                className="primary "
                label={i18n.t('MB_T_GOTO_MEETING')}
                disabled={!serviceCdList.includes(TERMS_TYPE.MEETING)}
                onClick={() => {
                  window.location.href = meetingDomain;
                }}
              />
              <Button
                componentType="solid"
                className="primary "
                label={i18n.t('MB_T_GOTO_DRIVE')}
                disabled={!serviceCdList.includes(TERMS_TYPE.DRIVE)}
                onClick={() => {
                  window.location.href = driveDomain;
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

InviteCompletion.propTypes = {};
InviteCompletion.defaultProps = {};
export default InviteCompletion;
